const getSelectOptionsSearchPage = (options) => {
  const newOptions = options.map((item) => ({
    value: item.id,
    label: item.name,
  }));
  return [{ value: null, label: "[ALL]" }, ...newOptions];
};

const refactorSearchMachinesData = (data) => {
  const newData = data.map((obj) => {
    const newObj = {};
    newObj["id"] = obj.id;
    newObj["name"] = obj.name;
    newObj["status"] = obj.status;
    for (let i = 1; i <= 5; i++) {
      if (obj.group_relation[`group_${i}`]) {
        newObj[`group_${i}_name`] = obj.group_relation[`group_${i}`].name;
      }
    }
    return newObj;
  });
  return newData;
};

const getParamSort = (sortOrderList) => {
  let sort = "";
  for (const key in sortOrderList) {
    if (sortOrderList[key] === 1) {
      sort = sort + `${key}_asc,`;
    }
    if (sortOrderList[key] === -1) {
      sort = sort + `${key}_desc,`;
    }
  }
  return sort.slice(0, -1);
};

export {
  getSelectOptionsSearchPage,
  refactorSearchMachinesData,
  getParamSort,
};
